// extracted by mini-css-extract-plugin
export default {"addTaskForm":"AddTask_addTaskForm__MD5zW","submitForm":"AddTask_submitForm__L+lR9","add":"AddTask_add__1UAWS","cancel":"AddTask_cancel__9L6WF"};